
import { defineComponent } from "vue";
import ProductBrandForm from "./Form.vue";

export default defineComponent({
  components: {
    ProductBrandForm,
  },
  setup() {
    return {};
  },
});
